import {gsap} from "gsap";
import {RoadKillGameMode} from "../server/RoadKillGameMode";

export class RKHelper {
    public static getTransitionAnimName(mode: string, nextMode: string): string {
        let animName: string = "";
        if (mode === RoadKillGameMode.NORMAL && nextMode === RoadKillGameMode.FREESPIN) {
            animName = "MainToFs";
        } else if (mode === RoadKillGameMode.NORMAL && nextMode === RoadKillGameMode.SUPER_FREESPIN) {
            animName = "SfsToMain";
        } else if (mode === RoadKillGameMode.NORMAL && nextMode === RoadKillGameMode.RESPIN) {
            animName = "MainTo2SW";
        } else if (mode === RoadKillGameMode.FREESPIN && nextMode === RoadKillGameMode.SUPER_FREESPIN) {
            animName = "FsToSFs";
        } else if (mode === RoadKillGameMode.RESPIN && nextMode === RoadKillGameMode.FREESPIN) {
            animName = "2SWToFs";
        } else if (mode === RoadKillGameMode.FREESPIN && nextMode === RoadKillGameMode.NORMAL) {
            animName = "FsToMain";
        } else if (mode === RoadKillGameMode.SUPER_FREESPIN && nextMode === RoadKillGameMode.NORMAL) {
            animName = "SfsToMain";
        } else if (mode === RoadKillGameMode.RESPIN && nextMode === RoadKillGameMode.NORMAL) {
            animName = "2SWToMain";
        }
        return animName;
    }

    public static playSpineWithTimeline(spine: PIXI.spine.Spine, trackIndex: number, animationName: string, animationAlpha: number = 1, mixDuration: number = 0, resetOnComplete: boolean = true): gsap.core.Timeline {
        const animation: PIXI.spine.core.Animation = spine.spineData.findAnimation(animationName);
        if (!animation) {
            throw new Error(`No animation named ${animationName}`);
        }

        spine.autoUpdate = false;

        const setAnimation = () => {
            const trackEntry: PIXI.spine.core.TrackEntry = spine.state.setAnimationWith(trackIndex, animation, false);
            trackEntry.alpha = animationAlpha;
            trackEntry.mixDuration = mixDuration;
        }

        const target = {
            playHead: 0,
            spine: spine,
            prevTime: 0
        }

        const updateFunc = () => {
            const now = target.playHead;
            spine.update(now - target.prevTime);
            target.prevTime = now;
        }

        const tl = gsap.timeline();
        tl.add(() => {
            target.prevTime = 0;
            setAnimation()
        });
        tl.add(gsap.fromTo(target, {playHead: 0}, {
            duration: animation.duration,
            playHead: animation.duration,
            onUpdate: updateFunc,
            ease: "none"
        }))
        if (resetOnComplete) {
            tl.add(() => {
                target.prevTime = 0;
                setAnimation();
            });
        }
        tl.add(gsap.to(target, {duration: 0.0001})); //Needed so gsap does not skip "setAnimation" during reverse play.
        tl.add(() => {
            target.playHead = animation.duration;
            updateFunc()
        })

        return tl;
    }
}